import { createSlice } from '@reduxjs/toolkit';
import { searchDevices } from './searchActions';

const initialState = {
    loading: false,
    devices: null,
    error: null,
    success: false
};

const searchSlice = createSlice({
    name: 'devices',
    initialState,
    reducers: {
        // logout: (state) => {
        //     localStorage.removeItem('userToken'); // delete token from storage
        //     state.loading = false;
        //     state.userInfo = null;
        //     state.userToken = null;
        //     state.error = null;
        // }
    },
    extraReducers: {
        [searchDevices.pending]: (state) => {
            state.loading = true;
            state.error = null;
        },
        [searchDevices.fulfilled]: (state, { payload }) => {
            state.loading = false;
            state.devices = payload;
        },
        [searchDevices.rejected]: (state, { payload }) => {
            state.loading = false;
            state.error = payload;
        }
    }
});

export default searchSlice.reducer;
